// История на промените на складов документ (доставка, изписване/бракуване,
// инвентаризация, прехвърляне): `GET /inventory/documents/{id}/revisions`.
//
// BE пази снимка на документа ПРЕДИ всяка редакция (и преди плащане/отмяна на
// плащане на доставка). `revisions` са стари → нови; всяка е състоянието преди
// промяната, направена от `changedByName` в `changedAt`. `current` е документът
// сега — в СЪЩАТА форма, за да се сравни последната снимка с него. Формата на
// снимката е Out-ът на GET по id на типа (Delivery / Writeoff / Stocktake /
// Transfer от `inventory.ts`) без мета полетата на статуса. Договорът е в
// docs/cross-repo-contract.md (ред 23).
import { api } from "./client";
import type { Delivery, Stocktake, Transfer, Writeoff } from "./inventory";

// Снимка на документ — един от четирите Out-а (без `status`/`createdAt`/…).
export type RevisionSnapshot = Partial<Delivery> | Partial<Writeoff> | Partial<Stocktake> | Partial<Transfer>;

// Типът на движението (изписване и бракуване са един документ)
export type RevisionMovementType = "delivery" | "writeoff" | "scrap" | "stocktake" | "transfer";

export interface DocumentRevision {
  revisionNo: number;
  changedAt: string; // кога е направена промяната, която снимката предхожда
  changedByName: string | null;
  snapshot: RevisionSnapshot; // документът ПРЕДИ промяната
}

export interface DocumentRevisions {
  movementId: number;
  movementType: RevisionMovementType;
  createdAt: string | null;
  createdByName: string | null;
  current: RevisionSnapshot;
  revisions: DocumentRevision[]; // стари → нови
}

export async function getDocumentRevisions(movementId: number): Promise<DocumentRevisions> {
  const res = await api.get<DocumentRevisions>(`/inventory/documents/${movementId}/revisions`);
  return res.data;
}
